import DOMPurify from "dompurify";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { PublicDocumentPayload } from "@/services/documentSharingService";

interface PublicDocumentShareViewProps {
  document: PublicDocumentPayload;
}

export function PublicDocumentShareView({ document: doc }: PublicDocumentShareViewProps) {
  const sanitizedContent = doc.content ? DOMPurify.sanitize(doc.content) : "";

  return (
    <div className="flex flex-col min-h-0 flex-1">
      <header className="border-b px-6 py-4 shrink-0">
        <h1 className="text-xl font-semibold">{doc.title || "Document"}</h1>
        <p className="text-sm text-muted-foreground mt-1">Shared document — read only</p>
      </header>
      <ScrollArea className="flex-1 min-h-0">
        <div className="p-6 max-w-3xl mx-auto">
          {sanitizedContent ? (
            <div
              className="prose prose-sm dark:prose-invert max-w-none"
              dangerouslySetInnerHTML={{ __html: sanitizedContent }}
            />
          ) : (
            <p className="text-muted-foreground text-sm">No content.</p>
          )}
        </div>
      </ScrollArea>
    </div>
  );
}
